<template>
  <div>
    <v-row>
      <h4 class="mt-2">
        (Нажмите на фото, чтобы его увеличить)
      </h4>
    </v-row>

    <v-row class="mt-4 photo-gallery">
      <v-col v-for="(photo, index) in photos" sm="4" :key="index" class="pl-1 pt-0 pr-1 photo-thumbnail" @click="openModal(photo)">
        <v-card height="100%" tile class="photo-card">
          <div v-if='isAdmin' class="icons-container">
            <v-btn v-if="canBeUpdated" class="icon-btn" icon @click.stop='openUpdateComponent(index)'>
              <v-icon color='primary'>mdi-pencil-circle</v-icon>
            </v-btn>
            <v-btn class="icon-btn" icon @click.stop="deletePhoto(index)">
              <v-icon color='red'>mdi-close-circle</v-icon>
            </v-btn>
          </div>
          <div class="photo-card">
            <v-img :src="baseCompressedPhotoUrl + '/' + photo.compressedPhotoPath"
                   :alt="`Этикетка ${index + 1}`"
                   class="thumbnail"
                   height="50vh" />
          </div>
          <p class="pa-4" v-if="photoType === 'photoOfSpeciesInNature'">
            {{photo.description}}
          </p>
        </v-card>
      </v-col>

      <transition name="fade">
        <div class="modal" v-if="showModal" @click="closeModal">
          <div class="modal-content">
            <v-icon class="close-icon" color='white' @click="closeModal">mdi-close-circle</v-icon>
            <img
                :src="baseOriginPhotoUrl + '/' + selectedPhoto.fullPhotoPath"
                 class="fullsize-image"
                 @click.stop
            >
          </div>
        </div>
      </transition>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "PhotoGalleryComponent",
  props: {
    photos: Array,
    baseCompressedPhotoUrl: String,
    baseOriginPhotoUrl: String,
    deletePhoto: Function,
    canBeUpdated: {Boolean, default: false},
    isAdmin: Boolean,
    photoType: String
  },
  data() {
    return {
      showModal: false,
      selectedPhoto: null
    };
  },
  methods: {
    openModal(photo) {
      this.selectedPhoto = photo;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    openUpdateComponent(index) {
      this.$emit('open-update-component', index)
    }
  }
};
</script>


<style>
.photo-gallery {
  display: flex;
  margin-bottom: 20px;
}

.photo-thumbnail {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.thumbnail {
  transition: transform 0.3s ease;
  object-fit: cover;
}

.photo-card:hover .thumbnail {
  transform: scale(1.1);
}

.photo-card {
  overflow: hidden;
  position: relative;
}

.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  transition: all 0.3s ease;
}

.close-icon {
  position: absolute;
  bottom: -24px;
  left: 0;
  cursor: pointer;
}

.modal-content img {
  max-width: 100vw;
  max-height: 100vh;
  object-fit: contain;
}

.icons-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 100;
}

.icon-btn {
  margin-bottom: 5px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>